import { useFormContext, Controller } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

type IProps = {
  name: string;
  dataTestId?: string;
  placeholder?: string;
  children: React.ReactNode;
  allowZero?: boolean;
};

type Props = IProps & TextFieldProps;

function rhfSelectDisplayValue(value: unknown, allowZero: boolean): string | number {
  if (allowZero) {
    return value == null ? '' : (value as string | number);
  }
  return value == null || value === 0 ? '' : (value as string | number);
}

export default function RHFSelect({
  name,
  dataTestId,
  placeholder,
  allowZero = false,
  children,
  ...other
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...fieldProps }, fieldState: { error } }) => (
        <TextField
          {...fieldProps}
          inputRef={ref}
          select
          aria-label={`${name}-aria-label`}
          value={rhfSelectDisplayValue(fieldProps.value, allowZero)}
          fullWidth
          error={!!error && !fieldProps.value}
          helperText={!!error && !fieldProps.value ? error.message : ''}
          data-testid={`${dataTestId}-select`}
          slotProps={{
            htmlInput: {
              'data-testid': dataTestId,
            },
          }}
          sx={{
            '& .MuiSelect-select span::before': {
              content: `"${placeholder ?? ''}"`,
              color: (theme) => theme.palette.text.disabled,
            },
          }}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  );
}
